import "../assets/XClose.css";
import { h as d, defineComponent as m, openBlock as c, createElementBlock as u, unref as s, withModifiers as p, createVNode as g } from "vue";
import { d as f } from "./debounce.BDLEW31m.js";
import { A as v } from "./maps.ChaVcqWI.js";
import { p as C } from "./widgets-core.es.DdX21Kyh.js";
import { o as w } from "./useStore.DvPy8fc7.js";
const h = (r, l) => {
  const i = "http://www.w3.org/2000/svg", e = new DOMParser().parseFromString(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M4.47 4.47a.75.75 0 011.06 0L10 8.94l4.47-4.47a.75.75 0 111.06 1.06L11.06 10l4.47 4.47a.75.75 0 11-1.06 1.06L10 11.06l-4.47 4.47a.75.75 0 01-1.06-1.06L8.94 10 4.47 5.53a.75.75 0 010-1.06z" clip-rule="evenodd"/>
</svg>
`, "image/svg+xml").firstChild;
  if (r.title) {
    const t = document.createElementNS(i, "title");
    t.textContent = r.title, e.appendChild(t);
  }
  const n = Array.from((e == null ? void 0 : e.attributes) ?? []).reduce((t, o) => ({
    ...t,
    [o.name]: o.value
  }));
  return d(
    "svg",
    {
      ...n,
      ...l.attrs,
      role: "img",
      innerHTML: e.innerHTML
    }
  );
}, x = ["aria-label"], B = /* @__PURE__ */ m({
  __name: "XClose",
  props: {
    triggerDismiss: { type: Boolean, default: !0 },
    onlyCloseModal: { type: Boolean, default: !1 }
  },
  setup(r) {
    const l = w(), { t: i } = C(), a = r, e = f(() => {
      var n;
      a.onlyCloseModal || a.triggerDismiss === !0 && ((n = l.handlers) == null || n.callHandler(v.Dismiss));
    }, 200, { leading: !0, trailing: !1 });
    return (n, t) => (c(), u("button", {
      type: "button",
      class: "thn--tool-xclose",
      "aria-label": s(i)("Close dialog"),
      onMousedown: t[0] || (t[0] = p(
        //@ts-ignore
        (...o) => s(e) && s(e)(...o),
        ["left"]
      )),
      onClick: t[1] || (t[1] = //@ts-ignore
      (...o) => s(e) && s(e)(...o))
    }, [
      g(s(h), {
        class: "thn--tool-xclose__svg",
        "aria-hidden": "true"
      })
    ], 40, x));
  }
});
export {
  B as _,
  h as i
};
//# sourceMappingURL=XClose.vue_vue_type_style_index_0_lang.BbzrX7pV.js.map
